export default __webpack_public_path__ + "8bf5e881bb67f2f805dd02c0d6998724.svg";